import api from "../../../api";
const API_URL = "/crm/currencies";
const RATE_URL = "/crm/currency-rates";

export async function getCurrencies() {
  const res = await api.get(API_URL);
  return res.data;
}

export async function getCurrency(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

export async function createCurrency(data) {
  const res = await api.post(API_URL, data);
  return res.data;
}

export async function updateCurrency(id, data) {
  const res = await api.put(`${API_URL}/${id}`, data);
  return res.data;
}

export async function deleteCurrency(id) {
  return api.delete(`${API_URL}/${id}`);
}

// Currency Rates
export async function getCurrencyRates() {
  const res = await api.get(RATE_URL);
  return res.data;
}

export async function getCurrencyRate(id) {
  const res = await api.get(`${RATE_URL}/${id}`);
  return res.data;
}

export async function createCurrencyRate(data) {
  const res = await api.post(RATE_URL, data);
  return res.data;
}

export async function updateCurrencyRate(id, data) {
  const res = await api.put(`${RATE_URL}/${id}`, data);
  return res.data;
}

export async function deleteCurrencyRate(id) {
  return api.delete(`${RATE_URL}/${id}`);
} 